import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  accountCompanyName,
  AdminDirectory,
} from "../../../api/adminDirectory";
import { EnumUserType } from "../../../generated/enums";
import { Account } from "../../../generated/types";
import { groupAccounts } from "../../../utils/accountGroups";
import { UserTypeBadge } from "./UserTypeBadge";

export const AccountGroups = ({
  accounts,
  directory,
  onSelect,
}: {
  accounts: Account[];
  directory: AdminDirectory;
  onSelect: (account: Account) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      {groupAccounts(accounts).map((group) => (
        <div
          key={group.space}
          className="border-l-2 border-secondary pl-4 ml-2"
        >
          <h4 className="flex items-center gap-2 mb-3 text-sm font-oxaniumMedium text-grey-dark">
            <FontAwesomeIcon icon={group.icon} />
            {t(group.label)} ({group.accounts.length})
          </h4>
          <ul className="space-y-2">
            {group.accounts.map((account) => {
              const companyName = accountCompanyName(directory, account);
              return (
                <li
                  key={account.id}
                  className="flex flex-wrap items-center gap-x-2 gap-y-1 border-b border-grey-light pb-2"
                >
                  <UserTypeBadge type={account.type as EnumUserType} />
                  <button
                    className="font-oxaniumMedium hover:text-tertiary cursor-pointer"
                    onClick={() => onSelect(account)}
                  >
                    {account.last_name} {account.first_name}
                  </button>
                  {companyName && (
                    <span className="text-sm text-grey-dark">
                      - {companyName}
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};
